const images = require.context("../images", true)
const audios = require.context("../audios", true)

const content = {
	imageContainerClass: "bg-extended pos-1",
	images: [
		{
			src: images("./last_cover_page_ma_ko_hun.png"),
			class: "image-one",
			imgdiv: "imageCoverDiv",
		},
	],
	texts: [
		{
			textDivClass: "story-text pageText element1 bhana-ma-ko-hun-page10 text-center",
			textIndivData: [
				{
					textData: "अहिले को लागि बाई बाई !",
					textClass: "m-0",
					timestamps: [{ start: 0 }, { start: 0.6 }, { start: 1 }, { start: 1.5 }, { start: 1.7, last: true }],
				},
			],
		},
	],
	sounds: [
		{
			url: audios("./final2.ogg"),
			delay: 4000,
		},
	],
}

export default content
